import localStore from '../../api/localStore'
import WebCalculations from '../../api/webCalculations.js'

const state = {}

const getters = {}

const actions = {
  async getItemsFromCache({ getters }, payload) {
    try {
      if (getters.isAuthenticated) {
        return await localStore.getItems(payload.objName, payload.parameters)
      }  else {
        return null
      }
    }
    catch (e) {
      return null
    }
  },
  async addAttachment({ commit }, payload) {
    commit('setLoading', true)
    try {
      if (payload.table && payload.keyvalue && payload.imageFiles && payload.imageFiles.length) {
        return await WebCalculations.submitFiles({
          files: payload.imageFiles,
          parameters: {
            table: payload.table,
            keyvalue: payload.keyvalue
          }
        })
      }
      //await ITserver.addAttachment(payload)
      commit('setLoading', false)
      commit('setSnackbarData', {
        color: 'green',
        text: 'Файлы загружен!'
      })
    }
    catch (error) {
      commit('setError', error.message)
      commit('setLoading', false)
      commit('setSnackbarData', {
        color: 'red',
        text: 'Ошибка загрузки файлов!'
      })
    }
  }
}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}